var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("validation-provider", {
            attrs: { rules: "area", name: _vm.nomeAba + "/Área" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("Label", {
                          attrs: { label: "Área", obrigatorio: true }
                        }),
                        _vm._v(" "),
                        _c("InputDouble", {
                          class: { erro: errors.length, input: "input" },
                          attrs: {
                            name: "Área",
                            precision: 2,
                            onkeypress: _vm.onlyInputNumbers,
                            showAppend: true
                          },
                          model: {
                            value: _vm.pratica.area,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "area", $$v)
                            },
                            expression: "pratica.area"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: "required",
              name: _vm.nomeAba + "Número de animais por área (unidade/ha)"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Número de animais por área (unidade/ha) ",
                            obrigatorio: true
                          }
                        }),
                        _vm._v(" "),
                        _c("InputDouble", {
                          class: { erro: errors.length, input: "input" },
                          attrs: {
                            name: "Número de animais por área (unidade/ha) ",
                            precision: 0,
                            onkeypress: _vm.onlyInputNumbers,
                            showAppend: true
                          },
                          model: {
                            value: _vm.pratica.numeroAnimais,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "numeroAnimais", $$v)
                            },
                            expression: "pratica.numeroAnimais"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("validation-provider", {
            attrs: {
              rules: "required",
              name: _vm.nomeAba + "/Data de início (mês/ano)"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Data de início (mês/ano)",
                            obrigatorio: true
                          }
                        }),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "Selecione mês e ano",
                            format: "MM/yyyy",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.pratica.dataInicio,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "dataInicio", $$v)
                            },
                            expression: "pratica.dataInicio"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("InputSelect", {
            attrs: {
              label: "Tipo de sistema:",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: "required",
              opcoes: _vm.opcoesTipoSistemaTI,
              widthColumn: _vm.containsOption(
                _vm.pratica.tiposSistemas,
                "OUTROS"
              )
                ? 5
                : 10,
              multiSelect: true
            },
            model: {
              value: _vm.pratica.tiposSistemas,
              callback: function($$v) {
                _vm.$set(_vm.pratica, "tiposSistemas", $$v)
              },
              expression: "pratica.tiposSistemas"
            }
          }),
          _vm._v(" "),
          _vm.containsOption(_vm.pratica.tiposSistemas, "OUTROS")
            ? _c("validation-provider", {
                attrs: {
                  rules: "required",
                  mode: "lazy",
                  name: _vm.nomeAba + "/Qual?"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c("Label", {
                                attrs: {
                                  label: "Outro/qual?",
                                  obrigatorio: true
                                }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: { name: "Outro/qual?" },
                                model: {
                                  value: _vm.pratica.outrosTipoSistema,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pratica,
                                      "outrosTipoSistema",
                                      $$v
                                    )
                                  },
                                  expression: "pratica.outrosTipoSistema"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(" " + _vm._s(errors[0]))
                              ])
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2313381574
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("TitleWithRow", { attrs: { title: "Espécies e raças" } }),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("InputSelect", {
                attrs: {
                  label: "Espécie",
                  nomeAba: _vm.nomeAba,
                  obrigatorio: true,
                  rulesInput: !_vm.pratica.especiesRacas.length
                    ? "required"
                    : "",
                  opcoes: _vm.opcoesEspecies,
                  widthColumn: 10
                },
                model: {
                  value: _vm.especiesRacas.especie,
                  callback: function($$v) {
                    _vm.$set(_vm.especiesRacas, "especie", $$v)
                  },
                  expression: "especiesRacas.especie"
                }
              }),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: !_vm.pratica.especiesRacas.length
                        ? "required"
                        : "",
                      mode: "lazy",
                      name: _vm.nomeAba + "/Raça"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("Label", {
                              attrs: {
                                label: "Raça",
                                obrigatorio: !_vm.pratica.especiesRacas.length
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              class: { "input erro": errors.length },
                              attrs: { name: "Raça" },
                              model: {
                                value: _vm.especiesRacas.raca,
                                callback: function($$v) {
                                  _vm.$set(_vm.especiesRacas, "raca", $$v)
                                },
                                expression: "especiesRacas.raca"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("div", { staticClass: "mb-1" }, [_vm._v(" ")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.disableButton,
                        round: "",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.btnAdicionar()
                        }
                      }
                    },
                    [_vm._v("\n          Adicionar\n        ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.pratica.especiesRacas.length
            ? _c("el-row", { attrs: { gutter: 20 } }, [
                _c(
                  "div",
                  { staticClass: "flex-wrapper row" },
                  _vm._l(_vm.pratica.especiesRacas, function(e, i) {
                    return _c(
                      "div",
                      { key: i + e.especie },
                      [
                        _c("Card", {
                          attrs: {
                            objeto: Object.assign({}, e, {
                              especie: _vm.pratica.especiesRacas
                                ? _vm.opcoesEspecies.find(function(especie) {
                                    return especie.id === e.especie
                                  }).nome
                                : "-"
                            }),
                            deletar: function() {
                              return _vm.btnApagar(i)
                            },
                            editar: function() {
                              return _vm.btnEditar(e, i)
                            },
                            titulo: "Espécies e raças"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Tipo de alimentação:",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: "required",
              opcoes: _vm.opcoesTipoAlimentacao,
              widthColumn: _vm.containsOption(
                _vm.pratica.tiposAlimentacao,
                "OUTROS"
              )
                ? 8
                : 10,
              multiSelect: true
            },
            model: {
              value: _vm.pratica.tiposAlimentacao,
              callback: function($$v) {
                _vm.$set(_vm.pratica, "tiposAlimentacao", $$v)
              },
              expression: "pratica.tiposAlimentacao"
            }
          }),
          _vm._v(" "),
          _vm.containsOption(_vm.pratica.tiposAlimentacao, "OUTROS")
            ? _c("validation-provider", {
                attrs: {
                  rules: "required",
                  mode: "lazy",
                  name: _vm.nomeAba + "/Qual?"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c("Label", {
                                attrs: {
                                  label: "Outro/qual?",
                                  obrigatorio: true
                                }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: { name: "Outro/qual?" },
                                model: {
                                  value: _vm.pratica.outroTipoAlimentacao,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pratica,
                                      "outroTipoAlimentacao",
                                      $$v
                                    )
                                  },
                                  expression: "pratica.outroTipoAlimentacao"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(" " + _vm._s(errors[0]))
                              ])
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2481755673
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: "required",
              name: _vm.nomeAba + "/Suplementação mineral"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("InputSelect", {
                      attrs: {
                        label: "Suplementação mineral",
                        nomeAba: _vm.nomeAba,
                        obrigatorio: true,
                        rulesInput: "required",
                        opcoes: _vm.opcoesSimNao,
                        widthColumn: _vm.containsOption(
                          _vm.pratica.tiposAlimentacao,
                          "OUTROS"
                        )
                          ? 8
                          : 10
                      },
                      model: {
                        value: _vm.pratica.hasSuplementacaoMineral,
                        callback: function($$v) {
                          _vm.$set(_vm.pratica, "hasSuplementacaoMineral", $$v)
                        },
                        expression: "pratica.hasSuplementacaoMineral"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Irrigacao", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c("Financiamentos", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 23 } },
            [
              _c("Label", { attrs: { label: "Descrição" } }),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  name: "Descrição",
                  type: "textarea",
                  maxlength: "500",
                  "show-word-limit": ""
                },
                model: {
                  value: _vm.pratica.descricao,
                  callback: function($$v) {
                    _vm.$set(_vm.pratica, "descricao", $$v)
                  },
                  expression: "pratica.descricao"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4817d992", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4817d992","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/TI/TI.vue
// module id = null
// module chunks = 